<script>
  export let value;
</script>

<div class='official'>
  <div class='official-box'>
    <!-- svelte-ignore a11y-missing-attribute -->
    <img class='official-box-nationality' src='img/static/flag/{value.nationality}.svg'>

    <div class='official-box-name'> {value.firstName} {value.lastName} </div>
  </div>
</div>

<style>
  .official {
    width: calc((100% - 20px) / 3);
  }

  .official:last-child {
    flex-grow: 1;
  }

  .official-box {
    display: flex;
    align-items: center;
    gap: 10px;

    padding: 10px 20px;

    border-radius: 5px;

    background: var(--grey-1);
  }

  .official-box-nationality {
    height: 20px;

    border-radius: 2px;
  }

  .official-box-name {
    font-weight: 550;
  }

  :global(body.dark) .official-box {
    background: var(--grey-8);
  }

  :global(body.dark) .official-box-nationality {
    filter: brightness(88%);
  }

  @media only screen and (max-width: 850px) {
    .official {
      width: calc((100% - 10px) / 2);
    }
  }

  @media only screen and (max-width: 850px) {
    .official {
      width: 100%;
    }
  }
</style>
